import Unsplash, { toJson } from 'unsplash-js';

const unsplash = new Unsplash({
    applicationId:
        '2c39701b6a24909ef877424f359429eccd96088d1919d5ded598fe7db45f04d5',
    secret: '15c2a3a64a0e2f4497a1b9cf65fab1a3193449c7ba7eae9f5db002e88b4d8236',
});

unsplash.auth.getAuthenticationUrl(['public']);

export function search(words, page, per_page) {
    return unsplash.search.photos(words, page, per_page).then(toJson);
}

export function listPhotos(page, per_page, orderBy) {
    return unsplash.photos.listPhotos(page, per_page, orderBy).then(toJson);
}

export function listCuratedPhotos(page, per_page, orderBy) {
    return unsplash.photos
        .listCuratedPhotos(page, per_page, orderBy)
        .then(toJson);
}

export function getRandomPhoto(queryParams) {
    return unsplash.photos.getRandomPhoto(queryParams).then(toJson);
}

export function triggerDownload(photo) {
    return unsplash.photos.downloadPhoto(photo);
}
